import { call, put, takeEvery } from 'redux-saga/effects'
import { Client } from 'WebAPI'
import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from './constants'

function* fetchClientSelects() {
  try {
    const { Data } = yield call(Client.getSelects)
    yield put(createAction(actions.client.FETCH_SUCCESS, { selects: Data }))
  } catch (error) {
    yield put(createAction(actions.client.FETCH_FAILURE, { error }))
  }
}

export default function* () {
  yield takeEvery(actions.client.FETCH, fetchClientSelects)
}
